import { startCase } from 'lodash';
export var UserType;
(function (UserType) {
    UserType[UserType["DashboardUser"] = 1] = "DashboardUser";
    UserType[UserType["FacilityAdmin"] = 2] = "FacilityAdmin";
    UserType[UserType["Contractor"] = 3] = "Contractor";
    UserType[UserType["Manufacturer"] = 4] = "Manufacturer";
    UserType[UserType["MaintenanceContractor"] = 5] = "MaintenanceContractor";
    UserType[UserType["ConsultantArchitect"] = 6] = "ConsultantArchitect";
    UserType[UserType["FootballFoundation"] = 7] = "FootballFoundation";
    UserType[UserType["SystemAdmin"] = 8] = "SystemAdmin";
    UserType[UserType["OtherUser"] = 9] = "OtherUser";
})(UserType || (UserType = {}));
export const getUserTypeString = (userTypeId) => {
    if (userTypeId === UserType.ConsultantArchitect) {
        return 'Consultant/Architect';
    }
    else {
        return startCase(UserType[userTypeId]);
    }
};
//# sourceMappingURL=userType.enum.js.map